import axios from '../utils/axios'

// 我的团队明细
export function teamMemberList(params) {
  return axios.post('/user/apiUserAh5Service/teamMemberList', params)
}
// 我的团队预览
export function teamOverview(params) {
  return axios.post('/user/apiUserAh5Service/teamOverview', params)
}
// 代理等级
export function getAgentLevelSetting(params = {}) {
  return axios.post('/user/apiUserAh5Service/getAgentLevelSetting', params)
}
// 获取代理关系总数
export function getAgentRelateCount(params) {
  return axios.post('/user/apiUserAh5Service/getAgentRelateCount', params)
}
